import { debounce, hashScrollTrigger } from "./Util.js";

/*
    Прелоадер
*/

// Время, за которое прелоадер полностью поднимается после загрузки страницы
//== @preloaderLoadedDelay + @preloaderLoadedDuration из _preloader.less
// export const PRELOADERHIDDEN = 1500;

if (App.H.hasClass("page-category")) {
    let heightHeader = $(".js-header .header").outerHeight();
    let heightCategoryNav = $(".js-category-top-nav").outerHeight();

    $(".js-category-top-nav li a").click(function (e) {
        e.preventDefault();
        $(".js-category-top-nav li a").removeClass("_active");
        $(this).addClass("_active");
        let elementClick = $(this).attr("href");
        let destination = $(elementClick).offset().top;
        $("html:not(:animated),body:not(:animated)").animate(
            { scrollTop: destination - (heightHeader + heightCategoryNav) },
            500
        );
        return false;
    });

    const scrollGlitchDebounce = debounce(() => {
        let $sectionNav = $(".js-section-nav");

        $sectionNav.each(function (idx, itm) {
            let idBlock = "#" + $(itm).attr("id");
            let wt = App.W.scrollTop();
            let wh = App.W.height();
            let et =
                $(itm).offset().top - (heightHeader + heightCategoryNav) + 100;
            let eh = $(itm).outerHeight();
            let $currLink = $(`.nav-item[href="${idBlock}"]`);

            if (wt + wh >= et && wt + wh - eh * 2 <= et + (wh - eh)) {
                $(".nav-item").removeClass("_active");
                $currLink.addClass("_active");
            } else {
                $currLink.removeClass("_active");
            }

            if (wt === 0) {
                $(".nav-item").removeClass("_active");
            }
        });
    }, 100);

    App.W.on("scroll", () => {
        scrollGlitchDebounce();
    });

    // $(window).on('scroll', function() {
    //     let scrollTop = $(this).scrollTop();
    //     console.log('prokrutili na', scrollTop);
    //     $('.section').each(function(item, index) {
    //         let topDistance = $(this).offset().top;
    //         console.log('offsetTop', topDistance);
    //         let idBlock = $(this).attr('id');
    //         if (topDistance - (heightHeader + heightCategoryNav + 100) < scrollTop) {
    //             $(`#`+idBlock).addClass('active');
    //         } else {
    //             $(`#`+idBlock).removeClass('active');
    //         }

    //         // if ($(item).offset().top - $('.js-category-top-nav').outerHeight() <= scrollTop) {
    // 		// 	$('.js-category-top-nav a').forEach((el) => {
    // 		// 		if ($(el).hasClass('active')) {
    // 		// 			$(el).removeClass('active');
    // 		// 		}
    // 		// 	});

    // 		// 	$('.js-category-top-nav li')[index].$('a').addClass('active');
    // 		// }
    //     });
    // });
}

App.W.on("preloader:loading", () => {
    // console.log('LOADING');
    startPreloader();
});

App.W.on("preloader:loaded", () => {
    // console.log('LOADED');
    finishPreloader();
});

App.W.on("preloader:unload", () => {
    // console.log('UNLOAD');
    startUnload();
});

// Начинаем показывать прелоадер
function startPreloader() {
    App.H.removeClass("_unloading _preloaded").addClass("_preloading");
}

// Скрываем прелоадер
function finishPreloader() {
    if (!App.H.hasClass("page-category")) {
        App.H.removeClass("_preloading _unloading").addClass("_preloaded");

        console.log("test finish perloader");
        setTimeout(hashScrollTrigger, 500);

        if (App.H.hasClass("page-about") && window.location.hash) {
            let idBlock = window.location.hash;
            setTimeout(() => {
                $("html, body").animate({
                    scrollTop: $(idBlock).offset().top - 150,
                });
            }, 200);
        }
    } else {
        App.H.removeClass("_preloading").addClass("_preloaded");
        setTimeout(hashScrollTrigger, 500);
    }
}

// Быстро закрываем (выгружаем страницу)
function startUnload() {
    App.H.removeClass("_preloading _preloaded").addClass("_unloading");
}



// WEBPACK FOOTER //
// ./_src/js/modules/Preloader.js